import { Grid } from "@mui/material";
import { Works } from "./works/Works";
import { Featured } from "./featured/Featured";
import { Apply } from "./apply/Apply";
import { PkCommonFooter } from "../../components/common/PkCommonFooter";
import { PkCommonHeader } from "../../components/common/PkCommonHeader";
export function ContributorPage() {
  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid xs={12} item>
      <PkCommonHeader/>
      </Grid>
      <Grid xs={12} item>
        <Works />
      </Grid>
      <Grid xs={12} item>
        <Featured />
      </Grid>
      <Grid xs={12} item>
      <PkCommonFooter />
      </Grid>
    </Grid>
  );
}
